import { render, staticRenderFns } from "./DiseaseInputForm.vue?vue&type=template&id=c166faa6&scoped=true&"
import script from "./DiseaseInputForm.vue?vue&type=script&lang=js&"
export * from "./DiseaseInputForm.vue?vue&type=script&lang=js&"
import style0 from "./DiseaseInputForm.vue?vue&type=style&index=0&id=c166faa6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c166faa6",
  null
  
)

export default component.exports